
interface NavbarProps {
  isScrolled: boolean;
}

function Navbar({ isScrolled }: NavbarProps) {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/80 backdrop-blur-xl shadow-[0_1px_0_rgba(0,0,0,0.06)]'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between h-14">
          <a href="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/c3b3b2cd4ef57e1a57418aa386255ad3.png"
              alt="Wazier AI"
              className="h-8 w-auto"
            />
          </a>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#solutions"
              className={`text-xs font-normal transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
              }`}
            >
              Solutions
            </a>
            <a
              href="#industries"
              className={`text-xs font-normal transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
              }`}
            >
              Industries
            </a>
            <a
              href="#process"
              className={`text-xs font-normal transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
              }`}
            >
              Process
            </a>
            <a
              href="#contact"
              className={`text-xs font-normal transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/80 hover:text-white'
              }`}
            >
              Contact
            </a>
            <a
              href="#contact"
              className={`px-5 py-1.5 text-xs font-medium rounded-full transition-all cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'bg-gray-900 text-white hover:bg-gray-800'
                  : 'bg-white/15 backdrop-blur-sm text-white border border-white/25 hover:bg-white/25'
              }`}
            >
              Book Strategy Call
            </a>
          </div>

          <button className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer">
            <i className={`ri-menu-line text-xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
